import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';

import {User} from './user';
import {DictResponse} from '../activate/dict-response';
import {Observable} from 'rxjs';
import {IsQueryResponse} from './is-query-response';
import {ServiceResponse} from './service-response';
import {MasbitHttpService} from '../../common/http/masbit-http.service';

@Injectable()
export class RegisterService {

  static readonly REGISTER_SERVICE_URL = environment.apiUrl.concat(environment.registerServiceUrl);
  static readonly SEND_ACCESS_REQUEST_URL = environment.apiUrl.concat(environment.userRegisterSendAccessRequest);
  static readonly IS_DOMAIN_SAFE_URL = environment.apiUrl.concat(environment.isSafeDomainServiceUrl);
  static readonly DICT_AREA_URL = environment.apiUrl.concat(environment.dictInterestAreaUrl);
  static readonly SEND_ACTIVATION_EMAIL_SERVICE_URL = environment.apiUrl.concat(environment.sendActivationEmailServiceUrl);

  registerUser(user: User) {
    const userParams = new HttpParams()
        .set('email', user.email)
        .set('password', user.password)
        .set('firstName', user.firstName)
        .set('lastName', user.lastName)
        .set('workPhone', user.workPhone)
        .set('preferredFormOfContact', user.preferredFormOfContact)
        .set('position', user.position)
        .set('area', user.area)
        .set('workExperience', String(user.workExperience))
        .set('agreement', String(user.agreement));

    return this.httpClient.get(RegisterService.REGISTER_SERVICE_URL, userParams );
  }

  sendEnquiry(firstName: string, lastName: string, userEmail: string, message: string, sendCopy: boolean, position? : string, phone? : string) {

    let enquiryParams = {
      firstName : firstName,
      lastName : lastName,
      email : userEmail,
      message : message,
      sendCopy : String(sendCopy),
      position : '',
      phone : ''
    };

    if (position)
      enquiryParams.position = position;
    if (phone)
      enquiryParams.phone = phone;

    return this.httpClient.post<{status: number, message: string}>(RegisterService.SEND_ACCESS_REQUEST_URL, enquiryParams);
  }

  isDomainSafe(email: string) : Observable<IsQueryResponse>{
    let domain: string;
    let emailSplitted = email.split('@');
    if (emailSplitted.length==2)
      domain=emailSplitted[1] ;

    return this.httpClient.post<IsQueryResponse>(RegisterService.IS_DOMAIN_SAFE_URL, {name: domain});
  }

  getArea(){
    return this.httpClient.get<Array<DictResponse>>(RegisterService.DICT_AREA_URL);
  }

  sendActivationEmail(email : string) : Observable<ServiceResponse> {
    return this.httpClient.post<ServiceResponse>(RegisterService.SEND_ACTIVATION_EMAIL_SERVICE_URL, {email : email});
  }

  constructor(private httpClient: MasbitHttpService) { }
}
